import type { LocationPageTabsProps } from "./location-page-tabs.type";
import type { TabViewItem } from "@/ui/tab-view";

import { useTranslation } from "react-i18next";

import { TAB_KEYS } from "@/constants/TabKeys";
import { LocationAssetsList } from "@/modules/location/location-assets-list";
import { LocationInterventionsList } from "@/modules/location/location-interventions-list";
import LocationMapTab from "@/modules/location/location-map-tab";
import { LocationProjectsList } from "@/modules/location/location-projects-list";
import LocationSectorsTab, {
  useLocationSectorsTabTitle,
} from "@/modules/location/location-sectors-tab";
import { TabView } from "@/ui/tab-view";

const LocationPageTabs = ({ location, loading }: LocationPageTabsProps) => {
  const { t } = useTranslation();

  const sectorsTabTitle = useLocationSectorsTabTitle(location);

  const tabs: TabViewItem[] = [
    {
      key: TAB_KEYS.LOCATION_MAP,
      label: t("global:map"),
      children: <LocationMapTab location={location} loading={loading} />,
      fullHeight: true,
    },
    {
      key: TAB_KEYS.LOCATION_SECTORS,
      label: sectorsTabTitle,
      children: <LocationSectorsTab location={location} loading={loading} />,
    },
    {
      key: TAB_KEYS.LOCATION_ASSETS,
      label: t("global:assetPlural"),
      children: <LocationAssetsList location={location} loading={loading} />,
    },
    {
      key: TAB_KEYS.LOCATION_INTERVENTIONS,
      label: t("global:interventionPlural"),
      children: (
        <LocationInterventionsList location={location} loading={loading} />
      ),
    },
    {
      key: TAB_KEYS.LOCATION_PROJECTS,
      label: t("global:projectPlural"),
      children: <LocationProjectsList location={location} loading={loading} />,
    },
  ];

  return <TabView isNav tabs={tabs} isFullHeight />;
};

export default LocationPageTabs;
